import { roadmapTypes } from "./roadmap.types";

export const setRoadmapData = (data) => ({
  type: roadmapTypes.SET_ROADMAP_DATA,
  payload: data,
});
